<template>
  <div>
    <list row-key="id" ref="list" unit="地址" :page="page" :query-params="params" :show-checkbox="showCheckbox"
      :show-query="showQuery" :get-data-func="getDataFunc">
      <template slot="toolbar-right">
        <!-- <slot name="toolbar-right"></slot> -->
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="query">
        <el-form-item label="快速筛选" label-width="112px">
          <el-input v-model="params.address" placeholder="请输入地址" clearable />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="address" label="地址" min-width="200px" />
        <el-table-column label="操作" width="80px" align="center">
          <template slot-scope="{row}">
            <el-button type="danger" @click="onDelete(row)">删除</el-button>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import editDialog from "./addressDialog"

export default {
  mixins: [listMixin],
  components: { list, editDialog },
  data() {
    return {
      // api: require("@/api/sy/user").default,
      params: {
        address: "",
      },
    };
  },
  methods: {
    getDataFunc(params) {
      // params = this.$commonJs.obj.removeNullKey({
      //   ...params,
      //   OrderType: this.quickSearch,
      //   SnField: this.snField,
      //   SnType: this.snType,
      //   [this.params.fieldType]: this.params.fieldValue
      // })
      return new Promise((resolve, reject) => {
        console.log("地址")
        resolve({ Code: 0, data: [], Msg: null })
        // this.api.list(params).then(res => {
        //   console.log("getDataFunc", params)
        //   resolve(res)
        // })
      })
    },
    create() {
      this.$refs.editDialog.openCreate()
    },
    onDelete(data) {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {

        console.log("删除", data)
      }).catch(() => { });
    },
    delRows(ids) {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = rows.map((item) => item.id);
        // this.api.delete({ ids }).then((res) => {
        //   if (res.Code == 0) {
        //     this.$message.success("删除成功");
        //     this.reload();
        //   } else {
        //     this.$message.error(res.Msg);
        //   }
        // });
      }).catch(() => { });
    },
  },
};
</script>